import { render, staticRenderFns } from "./MedicalCertEditor.vue?vue&type=template&id=21f4820b"
import script from "./MedicalCertEditor.vue?vue&type=script&lang=js"
export * from "./MedicalCertEditor.vue?vue&type=script&lang=js"
import style0 from "./MedicalCertEditor.vue?vue&type=style&index=0&id=21f4820b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports